import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
import PrimeResource from '../resources/prime-resouce';
import Notification from '../utils/notification-helper';
import Cons from '../../isomorphic/cons';

@inject('appStore')
@observer
export default class ContactList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            fileContacts: [],
            contacts: [],
            selectedContactId: props.selectedContactId ? props.selectedContactId : '',
            selectedContact: null,
        };
        this.primeResource = new PrimeResource();
    }

    componentWillReceiveProps(props) {
        let contacts = this.state.fileContacts;
        if (props.defaultContacts) contacts = props.defaultContacts.concat(contacts);

        this.setState({
            selectedContactId: props.selectedContactId ? props.selectedContactId : '',
            contacts: contacts,
        });
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        this.props.appStore.tcFileStore
            .getContactsForSelectedFile()
            .then(fileContacts => {
                let contacts = fileContacts;
                if (this.props.defaultContacts) contacts = this.props.defaultContacts.concat(fileContacts);

                this.setState({ contacts: contacts, fileContacts: fileContacts, isLoading: false });
            })
            .catch(err => {
                console.log(err);
                this.setState({ isLoading: false });
                Notification.ToastError('Failed to contacts');
            });
    }

    handleSelectedContactChange(contactId) {
        const selectedContact = _.find(this.state.contacts, contact => {
            return contact.contactId.toString() === contactId;
        });
        this.setState({ selectedContactId: contactId, selectedContact: selectedContact });

        if (_.isFunction(this.props.onChangeEvent)) {
            this.props.onChangeEvent(selectedContact);
        }
    }

    selectedContactChange(e) {
        this.handleSelectedContactChange(e.target.value);
    }

    render() {
        const filteredContacts = _.filter(this.state.contacts, contact => {
            return !(!(contact.firstName || contact.lastName) && !contact.email);
        });
        return (
            <select
                className="form-control"
                id="invoice-attn"
                value={this.state.selectedContactId}
                onChange={this.selectedContactChange.bind(this)}
            >
                <option value="">{this.state.isLoading ? 'Loading...' : 'Select a contact'}</option>
                {_.map(filteredContacts, contact => {
                    const contactLabel = Cons.prime.fileContactTypeLabel[contact.contactType] || contact.contactType;
                    const display = [
                        contactLabel,
                        contact.name || contact.firstName + ' ' + contact.lastName,
                        contact.companyName,
                        contact.email,
                    ].filter(s => {
                        return s;
                    });
                    return (
                        <option key={contact.contactId} value={contact.contactId}>
                            {display.join(' - ')}
                        </option>
                    );
                })}
            </select>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contact-list-component.js